module.exports = __webpack_public_path__ + "img/pangao_user_equipment_bg.81602a62.png";